import React, { FC, memo, useRef } from "react";

import StartDestination from "Components/StartDestination";
import { areEqualShallow } from "Utils/areEqual";

interface Props {
  showDirections: boolean;
  suggestions: any[];
  startingPoint: any;
  destination: any;
  setStartingPoint: (val: any) => void;
  setDestination: (val: any) => void;
  setShowDirections: (setShowDirections: boolean) => void;
  instructions: string[];
}
const StartDestinationContainer: FC<Props> = memo(
  ({
    showDirections,
    suggestions,
    startingPoint,
    destination,
    setStartingPoint,
    setDestination,
    setShowDirections,
    instructions,
  }: Props) => {
    const swapPoints = () => {
      setStartingPoint(destination);
      setDestination(startingPoint);
    };
    const directionsRef = useRef(null);

    return (
      <StartDestination
        showDirections={showDirections}
        setShowDirections={setShowDirections}
        suggestions={suggestions}
        startingPoint={startingPoint}
        destination={destination}
        setStartingPoint={setStartingPoint}
        setDestination={setDestination}
        swap={swapPoints}
        instructions={instructions}
        directionsRef={directionsRef}
      />
    );
  },
  areEqualShallow
);

export default StartDestinationContainer;
